
import { Injectable } from "@angular/core";

@Injectable()
export class ConstantsKey {
    public static X_AUTH_TOKEN = "X-AUTH-TOKEN";
    public static CONSUMER_DATA = "CONSUMER-DATA";
    public static CONSUMER_ID = "CONSUMER-ID";
    public static PAXID = "PAXID";
    public static OTP_LOGIN_RESPONSE = 'OTP_LOGIN_RESPONSE';
    public static LOGIN_USER_INFO = "LOGIN_USER_INFO";
    public static AGENT_ID = "AGENT-ID";
    public static AGENT_THEME = "AGENT-THEME";
    public static AGENT_KEY = "AGENT-KEY";

    public static BENEFICIARY_ORDER_DATA = "BENEFICIARY-ORDER-DATA";

    public static SS_ACTIVE_ORDER = "SESSION_STORAGE_ACTIVE_ORDER";
    public static SS_ACTIVE_ORDER_CARD = "SESSION_STORAGE_ACTIVE_ORDER_CARD";
    public static CARD_ADD_BALANCE_CURRENCY = "CARD_ADD_BALANCE_CURRENCY";
    public static SS_CARD_RATE_CALCULATOR = "SESSION_STORAGE_CARD_RATE_CALCULATOR";


    public static IS_FROM_EMAIL_LINK = "IS-FROM-EMAIL-LINK";
    public static EMAIL_LINK_DATA = "EMAIL-LINK-DATA";

    public static SS_ORDER_DATA = "SS-ORDER-DATA";
    public static BENE_ID = "BENE_ID";
    public static CONSUMER_SIGNATURE = "CONSUMER_SIGNATURE";
    public static CONSUMER_PAN = "CONSUMER_PAN";
    public static INSURANCE_RESPONSE = "INSURANCE_RESPONSE";
    public static INSURANCE_REQUEST = "INSURANCE_REQUEST";
    public static BENEFICIARY_PURPOSE_CODE = "BENEFICIARY_PURPOSE_CODE";
    public static INSURANCE_TYPE = "INSURANCE_TYPE";
    public static INSURANCE_CART_DETAILS = "INSURANCE_CART_DETAILS";
    public static QUOTATION_REQUEST_FOR_ENCASHMENT = "QUOTATION_REQUEST_FOR_ENCASHMENT";
    public static QUOTATION_RESPONSE_FOR_ENCASHMENT = "QUOTATION_RESPONSE_FOR_ENCASHMENT";
    public static ORDER_REQUEST = "ORDER_REQUEST";
    public static LINK_CARD_NAVIGATED = "LINK_CARD_NAVIGATED";
    public static IS_VCIP_COMPLETE = "IS_VCIP_COMPLETE";

    public static SSO_RESP = 'SSO_RESP';
    public static PRODUCT = 'PRODUCT';

    public static IS_FROM_RELOAD = "IS_FROM_RELOAD";
    public static IS_FROM_BUYNEWCARD = "IS_FROM_BUYNEWCARD";
    public static CARD_TYPE = "CARD_TYPE";

    public static PAYMENT_METHOD = 'PAYMENT_METHOD';
    public static IS_FROM_REMITTANCE_FLOW = "IS_FROM_REMITTANCE_FLOW";
    public static IS_FROM_RETRY_PAYMENT = "IS_FROM_RETRY_PAYMENT";
    

    public static MEDICAL_TREATMENT_ABROAD = 'MEDICAL_TREATMENT_ABROAD';
    public static EMIGRATION = 'EMIGRATION';
    public static OVERSEAS_EDUCATION = 'OVERSEAS_EDUCATION';
    public static PRIVATE_VISIT = 'PRIVATE_VISIT';


    
    public static SELECTED_CART_TYPE = 'SELECTED_CART_TYPE';
    public static WSFX_SELECTED_CARD_DATA = 'WSFX_SELECTED_CARD_DATA';
    public static STUDENT_CARD_APPLY = 'STUDENT_CARD_APPLY';
    public static ESIM_SELECTED_PLAN = 'ESIM_SELECTED_PLAN';
    public static ISIC_STATUS_DATA = 'ISIC_STATUS_DATA';
    public static MY_CARD_CHOOSE = 'MY_CARD_CHOOSE';
    public static STUDENT_CASHOUT_DATA = 'STUDENT_CASHOUT_DATA';
    public static MANAGE_CARD_STATUS = 'MANAGE_CARD_STATUS';
    public static IS_STUDENT_PAY_CARD = 'IS_STUDENT_PAY_CARD';
    public static CART_ORDER_TYPE = 'CART_ORDER_TYPE';
    public static CARD_LOGIN_ORIGIN = 'CARD_LOGIN_ORIGIN';
    public static CARD_ACTION = 'CARD_ACTION';
    public static CURRENT_PAGE_URL = 'CURRENT_PAGE';
    public static PREV_PAGE_URL = 'PREV_PAGE';
    public static ALL_USER_CARDS = 'ALL_USER_CARDS';
    public static WSFX_SELECTED_CARDS = 'WSFX_SELECTED_CARDS';
    public static ADD_ON_ORDER_TYPE = 'ADD_ON_ORDER_TYPE';
    public static SELECTED_LOUNGE = 'SELECTED_LOUNGE';
    public static CURRENT_ORDER_TYPE = "CURRENT_ORDER_TYPE";
    public static SELECTED_ESIM = 'SELECTED_ESIM';
    public static ESIM_ORDER_DATA = 'ESIM_ORDER_DATA';
    public static ADD_ON_RETRY_PAY_ORDER = 'ADD_ON_RETRY_PAY_ORDER';
    public static ENCASHMENT_ORDER_REQUEST_DATA = 'ENCASHMENT_ORDER_REQUEST_DATA';
    public static USER_PERSONA_PROFILE = 'USER_PERSONA_PROFILE';
    public static ORDER_DETAILS_PAGE_ESIGN_ACK = 'ORDER_DETAILS_PAGE_ESIGN_ACK';
    public static ORDER_DETAILS_PAGE_DATA = 'ORDER_DETAILS_PAGE_DATA';
    public static SMART_A2_FORM_OTP = 'SMART_A2_FORM_OTP';
    public static SSO_BRANCH_ID = 'SSO_BRANCH_ID';
    public static CHANGED_BRANCH_ID = 'CHANGED_BRANCH_ID';
    public static SET_CARD_PIN_ON_LINK = 'SET_CARD_PIN_ON_LINK';
    public static IS_IN_TRIP = 'IS_IN_TRIP';
    public static IS_IN_TRIP_DATA = 'IS_IN_TRIP_DATA';    
    
    public static REDIRECT_REMITTANCE_SECTION = 'REDIRECT_REMITTANCE_SECTION';    
    public static XPLORER_CARD_DATA = 'XPLORER_CARD_DATA';    



    public static IS_ESIM_ORDER_DONE = 'IS_ESIM_ORDER_DONE';   
    public static IS_LOUNGE_ORDER_DONE = 'IS_LOUNGE_ORDER_DONE'; 
    public static IS_INSURANCE_ORDER_DONE = 'IS_INSURANCE_ORDER_DONE'; 
    public static IS_STUD_REMITTANCE_ORDER_DONE = 'IS_STUD_REMITTANCE_ORDER_DONE';
    public static IS_PERS_REMITTANCE_ORDER_DONE = 'IS_PERS_REMITTANCE_ORDER_DONE';
     
    public static IS_CARD_ORDER_DONE = 'IS_CARD_ORDER_DONE'; 
    public static SELECTED_ESIM_REQUEST = 'SELECTED_ESIM_REQUEST';

    public static SELECTED_CURRENCY_BRANCH = 'SELECTED_CURRENCY_BRANCH';
    public static WALLET_TRANSFER_DATA = 'WALLET_TRANSFER_DATA';
    public static CONFIG_CORE_DATA = 'CONFIG_CORE_DATA';
    public static BUY_SWITCH_CARD_TYPE = 'BUY_SWITCH_CARD_TYPE';
    public static ENCASHMENT_ORDER_RESPONSE = 'ENCASHMENT_ORDER_RESPONSE';    
    public static ENCASHMENT_ORDER_TYPE = 'ENCASHMENT_ORDER_TYPE';     
    public static IS_CARD_BUY_FROM_CARDS_PAGE = 'IS_CARD_BUY_FROM_CARDS_PAGE';    
    public static IS_AD1_FLOW = 'IS_AD1_FLOW';
    public static IS_XPLORER_PURCHASE = 'IS_XPLORER_PURCHASE';    
    public static IS_ONLY_XPLORER_PURCHASE = 'IS_ONLY_XPLORER_PURCHASE';    
    public static XPLORER_CARD_PURCHASE_QUOTE = 'XPLORER_CARD_PURCHASE_QUOTE';    
    public static IS_XPLORER_ORDER_DONE = 'IS_XPLORER_ORDER_DONE';    
    public static XPLORER_SELECTED_ADDRESS = 'XPLORER_SELECTED_ADDRESS';
    public static IS_XPLORER_CARD_CALC = 'IS_XPLORER_CARD_CALC';
    public static IS_XPLORER_AMT_ADDED = 'IS_XPLORER_AMT_ADDED';
    
}